import * as ng from 'angular';
import '@uirouter/angularjs';
import 'angular-gettext';
import 'angular-cookie';
import 'ngmap';
import 'bootstrap/dist/js/bootstrap.bundle';
import 'ng-file-upload';

const app = ng.module('selfReg', [
   'ui.router',
   'gettext',
   'ipCookie',
   'ngMap',
   'ngFileUpload'
]);

export default app;

import './app.config';
import './app.routes';

import './layout';
import './shared';

import './age-gate';
import './confirmation';
import './events';
import './media-upload';
import './registration';
import './timeout';
